import { nwccDomain } from "@js/nwcc-domains.js";
import { getQueryArgs, getStates } from "@js/nwcc-navbar.js";
import { loadMainNwcc, setArgDetailsData } from "@js/nwcc-template.js";
import { getAllDataFiles } from "../model/get-data.js";
import { replaceHashWithSearchArg } from "@js/nwcc-utils.js";
const baseUrl = `${nwccDomain}/awdb`;

function getPageArgs() {
    return [
        {
            argName: "state",
            argDesc: "2-digit state code to filter plot dropdowns by.",
            argExample: "UT",
            argDefault: "ALL",
        },
    ];
}

window.onload = windowOnLoad;
export async function windowOnLoad() {
    setArgDetailsData(getPageArgs());
    installOpenPlotListeners();
    const args = getQueryArgs();
    const hasStateInArgs = Object.keys(args).includes("state");

    const validStates = getStates().map((stateObj) => {
        return stateObj.abbr.toUpperCase();
    });
    Object.keys(args).forEach((key) => {
        if (validStates.includes(`${args[key]}`.toUpperCase()) && !hasStateInArgs) {
            args.state = args[key].toUpperCase();
            delete args[key];
            replaceHashWithSearchArg(`?state=${args.state}`);
        }
    });

    const stateHash = args.state ? args.state : "ALL";
    const states = stateHash.split("-").map((s) => s.toUpperCase());
    const dataFiles = await getAllDataFiles();
    whenDataLoads(states, ...dataFiles);
    loadMainNwcc();
}

export function installOpenPlotListeners() {
    const openPlotButtons = document.querySelectorAll("button[id$=-btn]");
    openPlotButtons.forEach((button) => {
        button.addEventListener("click", function (e) {
            const ddId = this.id.replace("btn", "dd");
            const dropDownVal = document.getElementById(ddId).value;
            if (dropDownVal) {
                window.open(parseUrl(...JSON.parse(dropDownVal)), "_blank");
            }
        });
    });
}

export function parseUrl(siteName, stationTriplet, element, isFcst = false) {
    const sitePlotBaseUrl = `${baseUrl}/site-plots`;
    const startUrl = isFcst ? baseUrl : sitePlotBaseUrl;
    const state = stationTriplet.split(":")[1];
    const encodedName = encodeURIComponent(siteName);
    const searchQuery = new URLSearchParams(location.search);
    searchQuery.delete("state");
    const linkUrl = `${startUrl}/${element}/${state.toUpperCase()}/${encodedName}.html`;
    if (searchQuery?.size) {
        return `${linkUrl}?${searchQuery.toString()}`;
    }
    return linkUrl;
}

export function whenDataLoads(states, precMeta, wteqMeta, tavgMeta, snwdMeta, fcstMeta) {
    //smsMeta, stoMeta
    const includesAll = states.includes("ALL");
    function filterByNetworkAndState(siteMeta) {
        const [_, state, network] = siteMeta["stationTriplet"].split(":");
        return ["SNTL", "SNTLT", "MNST", "SCAN"].includes(network) && (includesAll || states.includes(state));
    }

    function sortbyName(a, b) {
        return a.name > b.name ? 1 : -1;
    }

    const [prec, wteq, tavg, snwd] = [precMeta, wteqMeta, tavgMeta, snwdMeta].map((meta) =>
        meta.filter(filterByNetworkAndState).sort(sortbyName),
    );

    //fcst has one different filter condition than the rest
    const fcst = fcstMeta
        .filter(
            (siteMeta) =>
                siteMeta.hasOwnProperty("fcstName") &&
                states.includes(siteMeta["stationTriplet"].split(":")[1]) | includesAll,
        )
        .sort(sortbyName);

    function fillDDandBadgeHtml(badgeId, ddId, data, element, isFcst) {
        const select = document.getElementById(ddId);

        data.forEach((siteMeta) => {
            const optionText = isFcst ? siteMeta.name : `${siteMeta["name"]} (${siteMeta["stationTriplet"]})`;
            const option = document.createElement("option");
            option.innerHTML = optionText;
            option.value = JSON.stringify([siteMeta["name"], siteMeta["stationTriplet"], element, isFcst]);
            select.appendChild(option);
        });

        if (!data.length) {
            select.closest("nwcc-select").parentElement.classList.add("fsa-hide");
        }

        document.getElementById(badgeId).innerHTML = data.length.toString();
    }

    fillDDandBadgeHtml("wteq-badge", "wteq-dd", wteq, "POR/WTEQ");
    fillDDandBadgeHtml("prec-badge", "prec-dd", prec, "POR/PREC");
    fillDDandBadgeHtml("tavg-badge", "tavg-dd", tavg, "POR/TAVG");
    fillDDandBadgeHtml("snwd-badge", "snwd-dd", snwd, "POR/SNWD");
    fillDDandBadgeHtml("wteq-proj-badge", "wteq-proj-dd", wteq, "Proj/WTEQ");
    fillDDandBadgeHtml("prec-proj-badge", "prec-proj-dd", prec, "Proj/PREC");
    fillDDandBadgeHtml("snow-flow-badge", "snow-flow-dd", fcst, "stf-plots", true);
}
